<template>
  <div>
    <b-modal
      v-model="previewDialog"
      size="md"
      :title="titulo"
      scrollable
      centered
    >
      <div v-if="isImage" class="image-container">
    <img
        id="image"
        :src="fileSrc"
        alt="Pré-visualização da imagem"
        class="preview-image"
        :style="{ transform: `rotate(${rotation}deg)` }"
    >
    </div>

    <div v-show="showloading" style="height: 0px" class="wait-loading"></div>

    <div class="d-flex justify-content-center mt-4" v-if="Array.isArray(documentos)">
        <core-GridToolbarButton
            text="Baixar"
            variant="outline-secondary icon-btn"
            icon="fas fa-download"
            @click="downloadArquivo"
            class="mr-2"
        />

        <core-GridToolbarButton
            text="Girar"
            variant="outline-secondary icon-btn"
            icon="fas fa-redo"
            @click="rotateImage"
            class="mr-2"
        />

        <core-GridToolbarButton
            text="Próximo"
            variant="outline-secondary icon-btn"
            icon="fas fa-arrow-right"
            @click="visualizarListaDocumento"
        />
    </div>

      <template #modal-footer>
        <b-button variant="primary" @click="closePreview">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import JSZip from "jszip";

export default {
  data() {
    return {
      previewDialog: false,
      fileSrc: null,
      isImage: false,
      showloading: true,
      countImagens: 0,
      documentos: null,
      tipoDocumento: null,
      titulo: 'Biometria',
      rotation: 0
    }
  },
  computed: {
    isBiometry() {
      return this.titulo.toLowerCase().includes('biometria');
    }
  },
  methods: {
    async showPreview(files, fileType) {
      this.previewDialog = true
      this.isImage = false
      this.showloading = true
      this.documentos = null
      this.tipoDocumento = null
      this.countImagens = 0
      this.rotation = 0

      await this.sleep(50)
      try {
        if (Array.isArray(files)) {
          this.documentos = files
          this.tipoDocumento = fileType
          this.visualizarListaDocumento()
          return
        }

        this.visualizarDocumentoUnico(files, fileType)
      } catch (error) {
        console.error('Erro ao pré-visualizar o documento:', error)
      }
    },
    sleep(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms)
      })
    },
    visualizarDocumentoUnico(file, fileType) {
      this.fileSrc = null

      const binaryString = window.atob(file)
      const len = binaryString.length
      const bytes = new Uint8Array(len)

      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }

      if (fileType.startsWith('image/')) {
        this.isImage = true
        const imagemBlob = new Blob([bytes.buffer], { type: fileType })
        this.fileSrc = URL.createObjectURL(imagemBlob)
        
        if (this.$refs.iframe_preview)
          this.$refs.iframe_preview.src = ''
      }

      this.showloading = false
      window.dispatchEvent(new Event('resize'))
    },
    visualizarListaDocumento() {
      if (this.countImagens != 0) {
        this.visualizarDocumentoUnico(this.documentos[this.countImagens], this.tipoDocumento)
        
        if (this.countImagens == (this.documentos.length - 1)) {
          this.countImagens = 0
          return
        }
      
        this.countImagens++
      } else {
        this.visualizarDocumentoUnico(this.documentos[this.countImagens], this.tipoDocumento)
        this.countImagens++
      }
    },
    rotateImage() {
      this.rotation = (this.rotation - 90) % 360
    },
    downloadArquivo() {
      let imagens = []

      for (let count = 0; count < this.documentos.length; count++) {
        const byteCharacters = atob(this.documentos[count])
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        
        imagens.push(new Uint8Array(byteNumbers))
      }

      const zip = new JSZip()

      imagens.forEach((image, index) => {
          zip.file(`Imagem_${index + 1}.jpg`, image, { binary: true })
      })

      zip.generateAsync({ type: "blob" })
        .then((content) => {
            const link = document.createElement("a")
            link.href = URL.createObjectURL(content)
            link.download = "BiometriaFacial.zip"
            link.style.display = "none"

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        })
    },
    closePreview() {
      this.previewDialog = false
      this.fileSrc = null
      if (this.$refs.iframe_preview) {
        this.$refs.iframe_preview.src = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-content {
    max-width: 30rem !important;
    margin: 0 auto;
  }
  .fade {
    width: 100%;
    height: 100%;
  }

.modal.fade.show.d-block {
    overflow-y: hidden;
    height: auto;
  }
}
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  overflow: hidden;
}

.preview-image {
  max-height: 100%;
  object-fit: cover;
  display: block;
  margin: auto;
  transition: transform 0.3s ease;
}
</style>